export default __webpack_public_path__ + "static/media/PPI-firefeature-020.bee23453.jpg";